export const DELETE_SUCCESS = 'Бонусная программа удалена';
export const DELETE_ERROR = 'Не удалось удалить бонусную программу';
